import React from 'react';

import { Button } from 'design-system-web';

import { useLabels } from './i18n/useLabels';

type Props = {
  onRetry: () => void;
};

export function ErrorFallback({ onRetry }: Props) {
  const labels = useLabels();

  return (
    <div role="alert">
      <p>{labels.errorMessage}</p>
      <Button variant="secondary" size="large" onClick={onRetry}>
        {labels.retry}
      </Button>
    </div>
  );
}
